/* global
AP
*/

import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { fetchExampleMapAsync, clearExampleMap, openExportDialogue } from '../../actioncreators/actioncreators'

import Questions from './questions'
import Rules from './rules'
import HelpButton from './helpButton'
import queryString from 'query-string'
import { hosts } from '../../actioncreators/hosts'
import swal from 'sweetalert'
import ExportDialogue from './exportDialogue'

const numberOfRulesToPromptSplit = 6

const Header = styled.div`
  display: flex;
  min-height: 48px;
  max-height: 48px;
  z-index: 10000;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f8f8f8;
  padding: 6px 10px;
  border-top: solid #ccc 1px;
  border-bottom: solid #ccc 1px;
  box-shadow: 0px 1px 3px #ccc;
`

const SaveMessage = styled.span`
  margin-right: 5px;
  color: #c0c0c0;
`

const InfoMessage = styled.div`
  padding: 6px 7px;
  border-radius: 4px;
  background-color: #d8dbe669;
  box-shadow: 0px 1px 2px 0px rgba(9,30,66,0.25);
`

const Body = styled.div`
  margin-top: 65px;
`

const SplashScreen = styled.div`
  max-height: calc(100% - 100px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 2px;
  box-shadow: 0px 1px 2px 0px rgba(9, 30, 66, 0.25);
  padding: 20px;
  z-index: 10000;
  font-size: 1.5em;
  background: #eaeaea;
`

const { Component } = React

const closeDialog = () => {
  AP.dialog.close()
}

function getInfoText (numberOfRules, numberOfExamples) {
  let info = null
  if (numberOfRules > numberOfRulesToPromptSplit) {
    info = 'You have ' + numberOfRules + ' rules. Consider splitting the story if it\'s getting complex.'
  } else if (numberOfRules > 1) {
    let ratio = numberOfRules / numberOfExamples
    if (ratio > 1.5) {
      info = 'Consider adding more examples.'
    } else if (ratio < 0.3) {
      info = 'You have lots of examples. Consider teasing out more rules.'
    }
  }
  return info
}

class Editor extends Component {
  componentWillMount () {
    const parsed = queryString.parse(window.location.search)
    if (this.props.host !== hosts.STANDALONE && parsed.lic !== 'active') {
      return
    }
    this.props.fetchExampleMap()
  }

  render () {
    let infoMessage = null
    if (this.props.infoMessage) {
      infoMessage = <InfoMessage title='Example map information'>{this.props.infoMessage}</InfoMessage>
    }

    return <div>
      <div>
        <Header>
          <img alt='Team Up Labs' src='teamuplabs.png' style={{ width: 130, height: 25 }} />
          {infoMessage}
          <div>
            <SaveMessage style={{ visibility: this.props.saveCounter > 0 ? 'visible' : 'hidden' }}>Saving</SaveMessage>

            <button onClick={this.props.openExportDialogue} className='btn btn-default' title='Export' style={{ marginRight: 5 }}><i className='fas fa-file-export' /></button>
            <button onClick={this.props.clear} className='btn btn-default' title='Clear Example Map' style={{ marginRight: 5 }}><i className='fas fa-broom' /></button>
            <span style={{ marginRight: 5 }} >
              <HelpButton />
            </span>
            <button onClick={closeDialog} className='btn btn-primary' style={{ display: this.props.host === hosts.STANDALONE ? 'none' : 'inline-block' }}>Finish Editing</button>
          </div>
        </Header>
        <Body>
          <SplashScreen style={{ display: this.props.numberOfRules === 0 ? 'block' : 'none' }}>
            <i className='fas fa-info-circle' /> Click the blue plus button to add a Rule. Click <a href='help.html' target='_tulhelp'>here</a> for instructions.
          </SplashScreen>
          <Rules />
          <Questions />
          <ExportDialogue />
        </Body>
      </div>
    </div>
  }
}

const mapStateToProps = function (store, ownProps) {
  let numberOfRules = 0
  let numberOfExamples = 0
  store.rules.forEach(row => {
    numberOfRules += row.length
    row.forEach(rule => {
      numberOfExamples += rule.examples.length
    })
  })

  return {
    saveCounter: store.general.saveCounter,
    infoMessage: getInfoText(numberOfRules, numberOfExamples),
    numberOfRules: numberOfRules,
    host: store.general.host
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    fetchExampleMap: () => dispatch(fetchExampleMapAsync()),
    clear: async () => {
      const shouldClear = await swal({
        title: 'Clear Example Map?',
        text: 'Click OK to clear this Example Map',
        icon: 'warning',
        buttons: true
      })
      if (shouldClear) {
        dispatch(clearExampleMap())
      }
    },
    openExportDialogue: () => dispatch(openExportDialogue())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor)
